import { render, staticRenderFns } from "./scroll-user.vue?vue&type=template&id=19330222&scoped=true&"
import script from "./scroll-user.vue?vue&type=script&lang=js&"
export * from "./scroll-user.vue?vue&type=script&lang=js&"
import style0 from "./scroll-user.vue?vue&type=style&index=0&id=19330222&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19330222",
  null
  
)

export default component.exports